import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import api from '@/lib/api';
import { useUserStore } from '@/stores/useUserStore';
import { AuthResponse, SignupRequest } from '@/types/auth';
import { ApiErrorResponse } from '@/types/api';

async function signup(data: SignupRequest): Promise<AuthResponse> {
  const response = await api.post<{ data: AuthResponse }>('/auth/signup', data);
  return response.data.data;
}

export function useSignup() {
  const login = useUserStore((state) => state.login);

  return useMutation({
    mutationFn: signup,
    onSuccess: (data) => {
      login(data.user, data.token);
      toast.success('Account created successfully!');
    },
    onError: (error: ApiErrorResponse) => {
      toast.error(error.response?.data?.message || 'Failed to create account');
    },
  });
}
